import { render, staticRenderFns } from "./WhaleioCapabilities.vue?vue&type=template&id=7da59261&"
import script from "./WhaleioCapabilities.vue?vue&type=script&lang=js&"
export * from "./WhaleioCapabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports